import React from 'react';
import epicTracking from 'epic-tracking';
import {LoginActions} from '../actions';
import {generateRoutePath} from 'epic-common/src/route';

export const useSignIn = (isLoggedIn, returnUrl, history) => {
    return React.useCallback(() => {
        epicTracking.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: 'LoginActions',
            eventAction: 'SignUp'
        });
        if (!isLoggedIn) LoginActions.requestLogin(returnUrl);
        if (isLoggedIn) history.push(generateRoutePath(returnUrl));
    }, [isLoggedIn, LoginActions, returnUrl]);
}
